/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Marketing_TextInputs */

const en_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I can unsubscribe at any time.`)
};

const de_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich kann mich jederzeit abmelden.`)
};

const fr_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je peux me desabonner a tout moment.`)
};

const es_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedo darme de baja en cualquier momento.`)
};

const it_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posso cancellarmi in qualsiasi momento.`)
};

const nl_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ik kan me op elk moment afmelden.`)
};

const pl_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moge zrezygnowac z subskrypcji w kazdej chwili.`)
};

const fi_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voin peruuttaa tilauksen milloin tahansa.`)
};

const da_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeg kan afmelde mig til enhver tid.`)
};

const sv_consent_marketing_text = /** @type {(inputs: Consent_Marketing_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jag kan avanmala mig nar som helst.`)
};

/**
* | output |
* | --- |
* | "I can unsubscribe at any time." |
*
* @param {Consent_Marketing_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_marketing_text = /** @type {((inputs?: Consent_Marketing_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Marketing_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_marketing_text(inputs)
	if (locale === "fr") return fr_consent_marketing_text(inputs)
	if (locale === "es") return es_consent_marketing_text(inputs)
	if (locale === "it") return it_consent_marketing_text(inputs)
	if (locale === "nl") return nl_consent_marketing_text(inputs)
	if (locale === "pl") return pl_consent_marketing_text(inputs)
	if (locale === "fi") return fi_consent_marketing_text(inputs)
	if (locale === "da") return da_consent_marketing_text(inputs)
	if (locale === "sv") return sv_consent_marketing_text(inputs)
	return en_consent_marketing_text(inputs)
});